(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('Headend', Headend);

    Headend.$inject = ['$resource'];

    function Headend ($resource) {
        var resourceUrl =  'api/headends/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },

            'download' : {
                method : 'GET',
                url : 'api/headends/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            }
        });
    }
})();
